import { bool, func, object, string } from 'prop-types'
import Uploader from '.'

const renderPromptText = (text) => <p>{text}</p>

const PreviewUploader = (props) => (
  <Uploader
    {...props}
    previewSrc={props.previewSrc}
    promptText={renderPromptText(props.promptText)}
    selected={props.selected}
    setSelectedAsset={props.setSelectedAsset}
    subText={renderPromptText(props.subText)}
    type="image-preview"
  />
)

PreviewUploader.propTypes = {
  iconName: string,
  iconStyles: object,
  previewSrc: string,
  promptText: string,
  selected: bool,
  setSelectedAsset: func,
  subText: string,
}

PreviewUploader.defaultProps = {
  iconName: 'drop-arrow',
  iconStyles: { height: 25, width: 40 },
  previewSrc: null,
  promptText: 'Drop an image here from your computer, or click to find one',
  selected: false,
  subText: 'Square or wide images work best.',
}

export default PreviewUploader
